import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { ROUTES } from '@/config/routeConfig';
import NotFound from '@/app/errors/NotFound';

const GUEST_AUTH_PATHS = new Set([
  ROUTES.LOGIN,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.VERIFY,
]);

export function isGuestAuthPath(pathname: string): boolean {
  return GUEST_AUTH_PATHS.has(pathname);
}

/**
 * Unknown paths: guests → login (avoids NotFound after session expiry on a
 * shell-specific URL). Authenticated users → 404.
 */
export function CatchAllRoute() {
  const { currentUser } = useUser();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

  return <NotFound />;
}
